<template>
  <div class="mb-4">
    <h5>{{ p_surveyItem.surveyItemName }}</h5>
    <textarea
      class="form-control"
      rows="5"
      :name="p_surveyItem.surveyItemKey"
      v-model="content"
      @input="handleInput"
    ></textarea>
  </div>
</template>
<script>
import { mapMutations } from 'vuex';

export default {
  name: 'SurveyItemTextarea',

  props: {
    p_surveyItem: {
      type: Object,
      default: () => ({}),
    },

    p_objValues: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      content: '',
    };
  },

  methods: {
    ...mapMutations('Mixins/Survey', {
      mm_UPDATE_SURVEY_ITEM: 'UPDATE_SURVEY_ITEM',
    }),

    handleInput() {
      this.mm_UPDATE_SURVEY_ITEM({
        ...this.p_surveyItem,
        i_isReady: '' !== this.content,
      });
    },
  },

  created() {
    const initV = this.p_objValues[this.p_surveyItem.surveyItemKey];
    this.content = initV ? initV : '';
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
